import { AxiosRequestConfig } from 'axios';

export default async (request: AxiosRequestConfig) => {
	const token = localStorage.getItem('keycloak-access-token');

	if (!request.headers) {
		request.headers = {};
	}

	if (token) {
		request.headers['Authorization'] = 'Bearer ' + token;
	}

	return request;
};
